"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getByName = void 0;
const next_utils_request_1 = __importDefault(require("@gerenciatd/next.utils.request"));
const next_utils_sonda_1 = __importDefault(require("@gerenciatd/next.utils.sonda"));
const next_utils_build_environments_1 = require("@gerenciatd/next.utils.build-environments");
const next_utils_environment_1 = require("@gerenciatd/next.utils.environment");
const next_utils_monitoring_1 = require("@gerenciatd/next.utils.monitoring");
const familyApi = 'custo';
const processName = 'ADABYRON-API';
const getByName = ({ name, icParams, context, preRenderEnv = '', build = true, kind = 'activity', urlParams = {}, }) => {
    const idRequest = (0, next_utils_monitoring_1.getUUID)();
    let sonda = null;
    if (!build) {
        sonda = new next_utils_sonda_1.default({
            eventName: 'CUSTO.GET_BY_NAME',
            context,
            uniqueId: idRequest,
            origin: processName,
        });
    }
    if (preRenderEnv) {
        const environments = (0, next_utils_environment_1.findOutEnvByHost)(preRenderEnv);
        context.environment = environments;
    }
    const { custo: connectionData } = context.environment;
    const { endpoint: host } = connectionData;
    let URL_API = `${host}/cms/{kind}/getByName?${idRequest}`;
    URL_API = URL_API.replace('{kind}', kind);
    let headers2Use = (0, next_utils_build_environments_1.calculateHeaderParams)(build, familyApi, context);
    headers2Use = Object.assign(Object.assign({}, headers2Use), { 'Content-type': 'text/plain;charset=UTF-8', 'content-type': 'text/plain;charset=UTF-8' });
    if (!build) {
        headers2Use = Object.assign(Object.assign({}, headers2Use), { withCredentials: true, Origin: 'https://qa.cms.col.movistar.es', 'Content-type': 'text/plain;charset=UTF-8', 'content-type': 'text/plain;charset=UTF-8' });
    }
    else {
        headers2Use = Object.assign(Object.assign({}, headers2Use), { Origin: 'https://www.movistar.es', 'Content-type': 'text/plain;charset=UTF-8', 'content-type': 'text/plain;charset=UTF-8' });
    }
    console.log('headers2Use', { headers2Use });
    const request = new next_utils_request_1.default({
        method: 'POST',
        endpoint: URL_API,
        headers: headers2Use,
        onSuccess: (response) => response.data,
        data: Object.assign(Object.assign({ name }, icParams), urlParams),
        sonda,
    });
    return request.makeRequest();
};
exports.getByName = getByName;
exports.default = exports.getByName;
//# sourceMappingURL=index.js.map